import {Component, OnInit} from "@angular/core";
import {NgSelectConfig, NgSelectModule} from "@ng-select/ng-select";
import {PaginatedBaseComponent} from "../../shared/paginated-base-component/paginated-base-component";
import {ActivatedRoute, Router, RouterModule} from "@angular/router";
import {RemedialSearchCriteria} from "src/app/_models/RemedialSearchCriteria";
import {RemedialStatus} from "src/app/_models/RemedialStatus";
import {Remedial} from "../../_models/Remedial";
import {RemedialService} from "../../_services/remedial.service";
import {StateManagementService} from "../../_services/state-management.service";
import {UserService} from "../../_services/user.service";
import {User} from "src/app/_models/User";
import {UserSearchCriteria} from "../../_models/UserSearchCriteria";
import {ToastrService} from "ngx-toastr";
import {FormsModule} from "@angular/forms";
import {TableSortWrapper} from "../../shared/table-sort/ts-wrapper.directive";
import {CommonModule} from "@angular/common";
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import {SharedModule} from "../../shared/shared.module";

@Component({
  standalone: true,
  imports: [
    FormsModule,
    NgSelectModule,
    RouterModule,
    TableSortWrapper,
    CommonModule,
    NgSelectModule,
    NgbPaginationModule,
    SharedModule
  ],
  templateUrl: 'my-remedials.component.html'
})
export class MyRemedialsComponent extends PaginatedBaseComponent implements OnInit {
  private readonly FilterKey = 'p-remedial-filter';

  public remedials: Remedial[] = [];
  public searchCriteria: RemedialSearchCriteria;
  public totalItems: number;
  public statuses: any[] = Object.keys(RemedialStatus).map(x => {
    return {id: x, name: x}
  })
  users: User[] = [];
  searchStatus?: string;
  createdBy?: string;

  constructor(
    protected toaster: ToastrService, protected route: ActivatedRoute,
    private remedialService: RemedialService, private stateManager: StateManagementService, private ngSelectConfig: NgSelectConfig) {
    super(toaster, route);
    this.searchCriteria = this.stateManager.getState<RemedialSearchCriteria>(this.FilterKey, {pageNumber: 1} as RemedialSearchCriteria);
    this.totalItems = 0;
    this.ngSelectConfig.bindValue = 'id';
  }

  ngOnInit() {

    this.searchStatus = this.route.snapshot.paramMap.get('status');
    this.createdBy = this.route.snapshot.paramMap.get('createdBy');

    //Clear existing filters when coming from dashboard
    if (this.searchStatus || this.createdBy) {
      this.stateManager.clearState(this.FilterKey);
      this.searchCriteria = new RemedialSearchCriteria();
    }

    if (this.createdBy) {
      this.searchCriteria.userId = this.createdBy;
    }

    if (this.searchStatus) {
      this.searchCriteria.status = this.searchStatus;
    }

    this.searchCriteria.userId = '';
    this.searchCriteria.status = '';
    this.searchCriteria.query = '';

    this.getRemedials();
  }

  setPage(page: number) {
    this.searchCriteria.pageNumber = page;
    this.getRemedials();
  }

  getRemedials() {
    this.searchCriteria.pageSize = 11;
    this.remedialService.searchRemedials(this.searchCriteria)
      .subscribe(remedials => {
      this.remedials = remedials.items;
      this.totalItems = remedials.totalCount;
      this.stateManager.setState(this.FilterKey, this.searchCriteria);
      this.paginationUpdated(this.searchCriteria.pageNumber);
      this.getUsers();
    });
  }

  getUsers() {
    let searchCriteria = new UserSearchCriteria();
    searchCriteria.pageSize = 9999;
    searchCriteria.name = '';
    searchCriteria.email = '';
    this.remedialService.searchUsers(searchCriteria)
      .subscribe(users => {
        this.users = users;
        this.users.forEach(x => {
          x.fullName = x.firstName + " " + x.lastName;
        })
      })
  }

  clearFilter() {
    this.stateManager.clearState(this.FilterKey);
    this.searchCriteria = new RemedialSearchCriteria();
    this.getRemedials();
  }
}
